import styled from "styled-components";

const HeaderStart = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export default HeaderStart;
